import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import { Button, Card } from '@/design-system/primitives';

export function ExpectScreen() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-30">
      <header>
        <div className="type-label-sm text-ink-muted">Submitted</div>
        <h1 className="type-display-lg mt-10">Here's what happens next.</h1>
        <p className="type-body-lg text-ink-secondary mt-15 max-w-prose">
          Your clinician will review your intake and reach out within 1–2 business days.
        </p>
      </header>

      <ol className="flex flex-col gap-15">
        <Step
          n={1}
          title="Clinician review · 1–2 days"
          body="A licensed clinician reads your intake. If they have questions, they'll start a thread in your Clinic tab."
        />
        <Step
          n={2}
          title="Protocol recommendation"
          body="They recommend a protocol tailored to your goals and history. You can discuss or adjust before anything ships."
        />
        <Step
          n={3}
          title="Shared approval"
          body="You approve the protocol directly in the portal. Your card is charged; your order enters processing."
        />
        <Step
          n={4}
          title="Shipped in 1–2 days"
          body="Pharmacy prepares and ships. Track your package from the Orders tab."
        />
      </ol>

      <Card padding="lg">
        <Card.Body>
          <div className="type-title-sm">Quarterly recalibration</div>
          <p className="type-body-sm text-ink-secondary mt-5">
            Every 12 weeks we check in to adjust your dose or cycle.
          </p>
        </Card.Body>
      </Card>

      <div className="flex justify-end">
        <Button onClick={() => navigate('/onboarding/complete')}>
          Continue <ArrowRight size={14} strokeWidth={1.5} />
        </Button>
      </div>
    </div>
  );
}

function Step({
  n,
  title,
  body,
}: {
  n: number;
  title: string;
  body: string;
}) {
  return (
    <li className="flex items-stretch gap-15 border border-line-subtle bg-raised overflow-hidden">
      <img
        src="/brand/clinic-scene.png"
        alt=""
        aria-hidden
        className="w-64 shrink-0 object-cover bg-[var(--surface-sunken)]"
      />
      <div className="flex items-start gap-15 p-15 flex-1 min-w-0">
        <div className="w-32 h-32 bg-accent-wash text-accent type-label-md flex items-center justify-center shrink-0">
          {n}
        </div>
        <div>
          <div className="type-title-sm">{title}</div>
          <p className="type-body-sm text-ink-secondary mt-5">{body}</p>
        </div>
      </div>
    </li>
  );
}
